export default "__VITE_ASSET__9da72fc2__"